/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { PatientPortalPatientData } from '../model/patientPortalPatientData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { environment } from '../../environments/environment';

@Injectable()
export class UpdatePatientPortalPatientDetailsService {

    protected basePath = environment.appSetting.apiUrl+'patientportal';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Referenced to SOA.UpdatePatientPortalPatientDetails
     * This API Updates patient details
     * @param patientData Update patient portal data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePatientPortalPatientDetails(patientData: PatientPortalPatientData, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public updatePatientPortalPatientDetails(patientData: PatientPortalPatientData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public updatePatientPortalPatientDetails(patientData: PatientPortalPatientData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public updatePatientPortalPatientDetails(patientData: PatientPortalPatientData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (patientData === null || patientData === undefined) {
            throw new Error('Required parameter patientData was null or undefined when calling updatePatientPortalPatientDetails.');
        }

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<number>(`${this.basePath}/UpdatePatientPortalPatientDetails`,
            patientData,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
